import React from "react";

import bowser from "bowser";

import toast from "~/ui/toast";

export default class BrowserCompatibilityWarning extends React.Component {
	componentDidMount(): void {
		const browser = bowser.getParser(window.navigator.userAgent);

		// Warn users about browsers we know don't work,
		// but don't pester folks who are using browsers we haven't tested yet,
		// because it's hard to keep up with all the new ones, and they may very well work fine.
		const invalidBrowser = browser.satisfies({
			chrome: "<84",
			chromium: "<84",
			firefox: "<69",
			opera: "<73",
			macos: {
				safari: "<14.1",
			},
			mobile: {
				safari: "<14.5",
			},
			windows: {
				"microsoft edge": "<84",
				"internet explorer": ">1", // No versions of IE work
			},
		});

		if (invalidBrowser) this.warnAboutIncompatibility();
	}

	warnAboutIncompatibility = (): void => {
		toast.error(
			`Warning: Fellow does not support your browser! You may encounter errors while using Fellow.
			Please upgrade to the latest version to ensure your experience is error-free.`,
			{ autoClose: false },
		);
	};

	render() {
		return null;
	}
}
